import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import * as React from "react";
import {
  AutocompleteInput,
  Button,
  Confirm,
  RadioButtonGroupInput,
  ReferenceInput,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { RequestType } from "../../../Enums/RequestType";
import appDataProvider from "../../../dataprovider";
import { ReliabilityReportType } from "../../../Enums/ReliabilityReportType";
const ReliabilityManualPoolCreate = ({ isOpen, onClose, reportType, ...rest }) => {
  const { http } = appDataProvider;
  const [questOpen, setQuestOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  var notify = useNotify();

  const handleClose = () => {
    setLoading(false);
    onClose?.();
  };
  const handleSubmit = values => {
    setLoading(true);
    isExclusionPn(values.type, values.requestId);
  };
  const isExclusionPn = (type, id) => {
    var values = { type: type, requestId: id, reportType: reportType };
    http
      .post("reliabilityreports/isexclusionpnbyrequest", values)
      .then(result => {
        if (result?.data === true) {
          setQuestOpen(true);
        } else {
          create(values);
        }
      })
      .catch(error => {
        console.log(error);
        create(values);
      });
  };
  const create = values => {
    http
      .post("reliabilityreports/manualcreate", { ...values })
      .then(result => {
        notify(`Successfully completed`, "success", false, true);
        handleClose();
      })
      .catch(error => {
        notify(error, "error", false, true);
      });
  };
  const onConfirmQuest = values => e => {
    create(values);
    onCloseQuest();
  };
  const onCloseQuest = () => {
    setQuestOpen(false);
    setLoading(false);
  };
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ type: 1, reportType: reportType }}
      render={({ handleSubmit, form, submitting, pristine, values, invalid }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Confirm
            isOpen={questOpen}
            title={""}
            content={"Do you want to create a record with an excluded pn?"}
            confirm={"Approve"}
            cancel={"Cancel"}
            onConfirm={onConfirmQuest(values)}
            onClose={onCloseQuest}
          />
          <Dialog open={isOpen} fullWidth={true} maxWidth={"xs"} onClose={handleClose}>
            <DialogTitle id="confirmation-dialog-title">
              {reportType === ReliabilityReportType.FailOnFit ? "Create Fail On Fit" : "Create Premature Failure"}
            </DialogTitle>
            <DialogContent dividers>
              <Grid container>
                <Grid item xs={12}>
                  <RadioButtonGroupInput
                    source="type"
                    choices={[
                      { id: RequestType.PBH, name: "PBH" },
                      { id: RequestType.RBH, name: "RBH" },
                    ]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ReferenceInput
                    disabled={!values.type}
                    label="Ref No"
                    source="requestId"
                    resource="refNo"
                    reference={
                      values.type == RequestType.PBH
                        ? "pbhrequestorders/getrefnowithunsvc"
                        : "requestorders/getrefnowithunsvc"
                    }
                    filterToQuery={optionText => ({ refNo__contains: optionText })}
                    enableGetChoices={({ q }) => q && q.length >= 4}
                  >
                    <AutocompleteInput
                      source="requestId"
                      optionText="refNo"
                      optionValue="id"
                      variant="outlined"
                      validate={required()}
                      fullWidth
                    />
                  </ReferenceInput>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" label="Close" onClick={handleClose} disabled={loading} color="default" />
              <Button
                variant="contained"
                label="Submit"
                type="submit"
                onClick={handleSubmit}
                disabled={loading || invalid}
                color="primary"
              />
            </DialogActions>
          </Dialog>
        </form>
      )}
    />
  );
};

export default ReliabilityManualPoolCreate;
